<template>
  <CategoryTop title="" description="" mainClass="training-container" />
  <div v-if="data" class="box-container">
    <div class="dashboard-header">
      <h2 class="font-32 fw-bold">{{ $t("points.board.title") }}</h2>
      <p class="font-20">{{ $t("points.board.headline1") }}</p>
    </div>

    <div class="points-summary">
      <div class="d-flex points-summary-row">
        <div class="points-box points-available points-box--bonus" v-if="showKickbackFeeList()">
          <h3 class="font-20 d-flex justify-content-between align-items-center">{{ kickbackFeeKey ===
            'kick_back_fee_tbr' ? 'TBR ' : '' }}{{ $t('kickback.title') }}</h3>
          <div class="font-45 fw-bold points-value">{{ formatCurrencyEur(kickbackFeeValue, currentLocale) }}</div>
        </div>
        <div class="points-box-group">
          <p class="points-box-label font-16 fw-bold text-uppercase">
            {{ $t("points.board.pointsBalanceToDate") }}
          </p>
          <div class="points-box points-available">
            <h3 class="font-20 d-flex justify-content-between align-items-center">{{ $t("points.board.availPoints")
            }} <img src="@/assets/img/star.svg" width="24" class="box-icon box-icon--positive" /></h3>
            <div class="font-45 fw-bold">{{ data.pointsSummary.available ?
              $filters.formatNumberWithCommas(data.pointsSummary.available) : 0 }}</div>
          </div>
        </div>
        <div class="points-box points-pending">
          <h3 class="font-20 d-flex justify-content-between align-items-center">{{
            $t("points.board.awaitingPoints") }} <img src="@/assets/img/lock.svg" width="24"
              class="box-icon box-icon--negative" /></h3>
          <div class="font-45 fw-bold">{{ data.pointsSummary.pending ?
            $filters.formatNumberWithCommas(data.pointsSummary.pending) : 0 }}</div>
        </div>
      </div>
      <div class="d-flex justify-content-end pt-2">
        <button class="action-btn fw-bold bg-white text-uppercase" @click="redirectToBankStatement()"
          :disabled="loading">{{
            $t("points.board.buttons.learnMore") }}</button>
      </div>
    </div>

    <div v-if="activePerformance.length > 0">
      <div class="performance-section" v-for="(performance, index) in activePerformance" :key="index">
        <MDBRow>
          <MDBCol cols="12" md="4">
            <h2 class="font-32 fw-bold">{{ $t("points.board.title2", { year: performance.year }) }}</h2>
            <p class="font-20">{{ $t("points.board.headline2") }}</p>
          </MDBCol>
          <MDBCol cols="12" md="8">
            <button class="action-btn fw-bold bg-white text-uppercase"
              @click="redirectToPromotion(performance.campaignUrl)" :disabled="loading">{{
                $t("points.board.buttons.learnMoreAboutMechanism") }}</button>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <div class="font-16 fw-bold">{{ $t("points.board.yourRealisation") }}</div>
              <div class="font- pb-3"
                v-html="$t('points.board.yourEngagement', { tyres: performance.realisation.engagementTarget })">
              </div>
              <GaugeChart :remaining="performance.realisation.remaining"
                :target="performance.realisation.engagementTarget" :achieved="performance.realisation.remaining" />
            </div>
          </MDBCol>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <p class="font-16 fw-bold">{{ $t("points.board.yourPoints") }}</p>
              <p class="font-16"> {{ $t("points.board.pointsByBSPurchase") }}</p>
              <div class="d-flex w-100">
                <div class="w-50 text-center">
                  <div class="font-20 font-xl-25 font-lg-52 fw-bold">{{
                    $filters.formatNumberWithCommas(performance.points.purchasePoints) ?? 0 }}</div>
                  <div class="px-2 font-15 font-lg-15 font-xl-20 fw-bold">{{
                    $t("points.board.pointsByPurchase") }}</div>
                </div>
                <div class="w-50 border-left text-center">
                  <div class="font-20 font-xl-25 font-lg-52 fw-bold">{{
                    $filters.formatNumberWithCommas(performance.points.boosterPoints) ?? 0 }}</div>
                  <div class="px-2 font-15 font-lg-15 font-xl-20 fw-bold">{{
                    $t("points.board.pointsByBoosters") }}</div>
                </div>
              </div>
            </div>
          </MDBCol>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <p class="font-16 fw-bold">{{ $t("points.board.yourRetailPurchase") }}</p>
              <div class="d-flex flex-wrap">
                <div class="font-16 pe-4" v-if="performance.retailPurchase.charts.byBrand">
                  <PieChart :data="performance.retailPurchase.charts.byBrand"
                    :centerText="$t('points.board.charts.byBrand')" />
                </div>
                <div class="font-16 border-left ps-md-4" v-if="performance.retailPurchase.charts.bySize">
                  <PieChart :data="performance.retailPurchase.charts.bySize"
                    :centerText="$t('points.board.charts.bySize')" legendPosition="down" :reduceColors="true" />
                </div>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </div>

    <div v-if="activeBoosterCCS.length > 0">
      <MDBRow>
        <MDBCol cols="12">
          <h2 class="font-32 fw-bold">ANIMATION BOOSTER CCS</h2>
        </MDBCol>
      </MDBRow>
      <div class="performance-section" v-for="(boosterCCS, index) in activeBoosterCCS" :key="index">
        <MDBRow>
          <MDBCol cols="12" md="4">
            <h2 class="font-20 fw-bold">ANIMATION {{ boosterCCS.title }}</h2>
          </MDBCol>
          <MDBCol cols="12" md="8">
            <button class="action-btn fw-bold bg-white text-uppercase"
              @click="redirectToPromotion(boosterCCS.campaignUrl)" :disabled="loading">{{
                $t("points.board.buttons.learnMoreAboutMechanism") }}</button>
          </MDBCol>
          <MDBCol cols="12" md="12">
            <p class="font-20">{{
              $t("points.board.exploreResults") }}.</p>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <div class="font-16 fw-bold">{{ $t("points.board.yourRealisation") }}</div>

              <div class="w-100 py-4">
                <div class="text-center">
                  <img src="@/assets/img/points_board/std-rim.png" alt="">
                </div>
              </div>
              <div class="font-35 fw-bold text-center text-success">{{ boosterCCS.realizations }}</div>
              <div class="font-20 text-center fw-bold py-2">{{ $t("points.soldTyres") }}</div>
              <hr>
              <div class="font-12">{{
                $t("points.board.tyreLimitInfo") }}</div>
            </div>
          </MDBCol>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <div>
                <p class="font-16 fw-bold">{{ $t("points.board.yourPoints") }}</p>
                <p class="font-16"> {{ $t("points.board.pointsByBSPurchaseCCS") }}</p>
              </div>
              <div class="w-100">
                <div class="text-center">
                  <img src="@/assets/img/points_board/reward-icon.png" alt="">
                </div>
              </div>
              <div class="font-35 fw-bold text-center text-success">{{ boosterCCS.points }}</div>
              <div class="font-20 text-center fw-bold py-2">{{ $t("points.receivedPoints") }}</div>
            </div>
          </MDBCol>
          <MDBCol cols="12" md="6" lg="6" xl="4">
            <div class="performance-col">
              <p class="font-16 fw-bold">{{ $t("points.board.yourRetailPurchaseCCS") }}</p>
              <div class="d-flex flex-wrap">
                <div class="font-16 pe-4" v-if="boosterCCS.byBrand">
                  <PieChart :data="boosterCCS.byBrand" :centerText="$t('points.board.charts.byBrand')" />
                </div>
                <div class="font-16 border-left ps-md-4" v-if="boosterCCS.bySize">
                  <PieChart :data="boosterCCS.bySize" :centerText="$t('points.board.charts.bySize')"
                    legendPosition="down" :reduceColors="true" />
                </div>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </div>

  </div>
  <Loader :show="true" v-else />
</template>
<script setup>
import Loader from "@/components/General/Loader/index.vue";
import PieChart from "@/components/Shared/PieChart.vue"
import GaugeChart from "@/components/Shared/GaugeChart.vue"
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import { MDBCol, MDBRow } from "mdb-vue-ui-kit";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { userCanSeeKickbackList } from "@/composables/useProfileFieldCheck";

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { computed, ref } from "vue";
import { formatCurrencyEur } from "@/utils/formatCurrency";

const store = useStore();
const router = useRouter();
const { tenantConfig } = useTenantConfig();
store.dispatch("fetchPointBoard");

const data = computed(() => store.getters.getPointBoard)
const loading = ref(false)
const currentLocale = computed(() => store.getters.getCurrentLocale || "en-GB");
const { showKickbackFeeList } = userCanSeeKickbackList(tenantConfig);
const kickbackFeeKey = computed(() => tenantConfig.value.kickbackFeePointsKey || "kick_back_fee");
const kickbackFeeValue = computed(() => data.value?.pointsSummary?.[kickbackFeeKey.value] ?? 0);
const activePerformance = computed(() =>
  (data.value?.performance ?? []).filter((campaign) => campaign?.isActive === true)
);
const activeBoosterCCS = computed(() =>
  (data.value?.boosterCCS ?? []).filter((campaign) => campaign?.isActive === true)
);

const redirectToPromotion = (subpage = null) => {
  window.location.href = subpage;
};

const redirectToBankStatement = () => {
  router.push({
    name: "pointsOverview"
  });
}
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/points_board.scss";
</style>
